<template>
  <div class="cpnt-app-toggle-2 cpnt-app-campo" v-show="cpntMostrar" :id="cpntId">
    <!-- SETA OS BOTOES EXISTENTES -->
    <div>
      <button v-for="(button, index) in cpntOptions" :key="index" :style="'width: ' + (100 / cpntOptions.length) + '%;'"
        :tabIndex="cpntTabIndex" 
        class="btn btn-sm" 
        :class="(typeof cpntValue === 'string' ? cpntValue : cpntValue[cpntKeyValue]) === button[cpntKeyValue] ? 'btn-primary' : 'btn-default'"
        :disabled="button.disabled === true"
        @click="cpntToggles2OnChange(button[cpntKeyValue])">
        <span v-for='(key, keyIndex) in cpntKeyMostra' :key="keyIndex">
          <span v-if='button.hasOwnProperty(key)' v-html='button[key]'></span>
          <span v-else v-html='key'></span>
        </span>
      </button>
    </div>
    
    <!-- SETA O ICONE DE CARREGANDO -->
    <!-- <div v-if="loading === true" class="cpnt-app-toggle-loading" title="Carregando...">
      <svg class="fas fa-spinner fa-spin"></svg>
    </div> -->

    <!-- SETA A BARRA QUE APRESENTA ABAIXO DO INPUT -->
    <span class="cpnt-barra"></span>
    
    <!-- SETA O TITULO DO CAMPO -->
    <label :for='cpntId' v-if="[ '', null, undefined ].indexOf(cpntNome) === -1 || [ '', null, undefined ].indexOf(cpntExplica) === -1">
      <!-- SETA O NOME DO CAMPO -->
      <span v-if="[ '', null, undefined ].indexOf(cpntNome) === -1" v-html='cpntNome'></span>

      <!-- SETA A EXPLICAÇÃO DO CAMPO -->
      <App-Explica v-if="[ '', null, undefined ].indexOf(cpntExplica) === -1"
        :cpntId='cpntId + "-explica"' 
        :cpntTitle='cpntExplica.mensagem'
        :cpntPositionMy='cpntExplica.posicaoMy'
        :cpntPositionAt='cpntExplica.posicaoAt'
        :cpntClasses='cpntExplica.class'
      ></App-Explica>
    </label>

    <!-- SETA UM AVISO ABAIXO DO CAMPO -->
    <span class="cpnt-has-error" v-if="[ '', null, undefined ].indexOf(cpntMensagem) === -1" v-html='cpntMensagem'></span>
  </div>
</template>

<style scoped>
  .cpnt-app-toggle-2 > div > button:first-child {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-right: none;
  }
  .cpnt-app-toggle-2 > div > button:not(:first-child):not(:last-child) {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  .cpnt-app-toggle-2 > div > button:last-child {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: none;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // PROCURAR A MONTAGEM DO CAMPO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-toggles-2-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntValue: {
        required: true,
        type: [ String, Number, Object ]
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntOptions: {
        type: Array,
        required: true
      },
      cpntKeyValue: {
        type: String,
        required: true
      },
      cpntKeyMostra: {
        type: Array,
        required: true
      },

      cpntOnChange: {
        required: true,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    methods: {
      cpntToggles2OnChange: function (value) {
        if (value !== this.cpntValue) {
          this.cpntOnChange(value, this.cpntId)
        }
      }
    }
  }
</script>
